import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Card, CardHeader, CardBody, Row, Col, Button, Label, FormGroup } from 'reactstrap'
import { getProvider, resetProvider } from '../../../../store/provider/actions'
import { MainLoader } from '../../../../components'


class ProviderDetail extends Component {

    componentDidMount() {
        this.props.getProvider(this.props.match.params.id)
    }

    componentWillUnmount() {
        this.props.resetProvider();
    }

    renderField(label, value) {
        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label color='red'>{label}</Label>
                </Col>
                <Col xs="12" md="5">
                    <p className="form-control-static">{value}</p>
                </Col>
            </FormGroup>
        )
    }

    renderFields() {

        const provider = this.props.provider

        return (
            <div>
                {this.renderField('Código:', provider.code)}
                {this.renderField('Nombre:', provider.name)}
                {this.renderField('RUC:', provider.ruc)}
                {this.renderField('Teléfono:', provider.phone)}
                {this.renderField('Email:', provider.email)}
                {this.renderField('Banco:', provider.bank)}
                {this.renderField('Cuenta:', provider.bankAccount)}
                {this.renderField('Comentarios:', provider.comments)}
            </div>
        )
    }

    render() {
        const { provider, loading, error } = this.props

        if (error) {
            return (
                <Alert color="danger">
                    {error}
                </Alert>
            )
        }

        if (loading) {
            return <MainLoader />
        }
        else if (!provider) return <div></div>

        return (
            <div className='animated'>
                <Card>
                    <CardHeader>
                        Detalle del Proveedor
                    </CardHeader>
                    <CardBody>
                        {this.renderFields()}
                        <Row>
                            <Col className='mt-3'>
                                <Button color='secondary' onClick={() => this.props.history.push('/administration/providers')} ><i className="fa fa-chevron-left mr-1" /> Volver</Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

function mapStateToProps(state) {

    const { provider, error, loading } = state.provider.activeProvider

    return {
        provider,
        error,
        loading,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getProvider,
        resetProvider
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ProviderDetail)



// WEBPACK FOOTER //
// ./src/scenes/Administration/Provider/ProviderDetail/ProviderDetail.js